import PropTypes from 'prop-types';
import React from 'react';

import CloseIcon, { SIZES } from 'components/CloseIcon';
import IconButton from 'components/IconButton';
import VideoPlayer from 'components/VideoPlayer';

/**
 * Renders an inline video player component for the HeroSlide component.
 *
 * @param {object} props - The component props.
 * @param {string} props.videoUrl - The URL of the video to be played.
 * @param {function} props.onClose - A callback function to be called when the video player is closed.
 * @param {object} otherProps - Any additional props to be passed to the VideoPlayer component.
 * @returns {JSX.Element} The inline video player component.
 */
const InlineVideoPlayer = ({ videoUrl, onClose, ...otherProps }) => (
  <div className="absolute inset-0 z-20 bg-black">
    <VideoPlayer
      aspectRatio="1:.43"
      controls
      onEnded={onClose}
      playing
      playsinline
      url={videoUrl}
      {...otherProps}
    />
    <IconButton onClick={onClose} className="CloseButton absolute !right-4 !top-4">
      <CloseIcon size={SIZES.LARGE} className="before:!bg-white after:!bg-white" />
    </IconButton>
  </div>
);

InlineVideoPlayer.propTypes = {
  videoUrl: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default InlineVideoPlayer;
